document.addEventListener('alpine:init', () => {
  // Componente específico para items del carrito - Versión independiente con nombre único
  Alpine.data('NailthoughtsCartItemQuantity', () => ({
    quantity: null,
    init() {
      // Inicializar la cantidad desde el input
      this.$nextTick(() => {
        this.quantity = parseInt(this.$refs.quantityInput.value) || 0;
      });
    },
    
    // Función para ajustar cantidad
    adjustQuantity(adjustCb) {
      if (typeof this.previousQuantity !== "undefined") {
        this.previousQuantity = this.quantity;
      }
      const quantityBeforeAdjustment = this.quantity;
      adjustCb();
      this.dispatchInputEvent();
      if (this.quantity === quantityBeforeAdjustment) return;
      this.$nextTick(() => {
        this.dispatchChangeEvent();
      });
    },
    
    // Incrementar cantidad
    increment() {
      this.adjustQuantity(() => {
        this.$refs.quantityInput.stepUp();
        this.quantity = parseInt(this.$refs.quantityInput.value) || 0;
      });
    },
    
    // Decrementar cantidad
    decrement() {
      this.adjustQuantity(() => {
        this.$refs.quantityInput.stepDown();
        this.quantity = parseInt(this.$refs.quantityInput.value) || 0;
      });
    },
    
    // Remover item
    remove() {
      this.adjustQuantity(() => {
        this.$refs.quantityInput.value = 0;
        this.quantity = 0;
      });
    },
    
    // Manejar cambio de cantidad
    itemQuantityChange() {
      // Crear un evento personalizado para comunicarse con el componente padre
      this.$dispatch('cart-quantity-changed', {
        input: this.$refs.quantityInput,
        quantity: this.quantity,
        lineItemKey: this.$root.closest('li[data-cart-item-key]')?.getAttribute('data-cart-item-key')
      });
    },
    
    // Disparar eventos de input y change
    dispatchInputEvent() {
      this.$refs.quantityInput.dispatchEvent(new Event("input"));
    },
    
    dispatchChangeEvent() {
      this.$refs.quantityInput.dispatchEvent(new Event("change"));
    }
  }));
});
